import type React from 'react';
import { useEffect, useMemo, useState } from 'react';

import { DataSchemaContext } from '@ragu-components/ord-components';
import {
  fetchClientConfig,
  CONFIG_PATH,
  createConfig,
  setupBaseConfig,
  ConfigContext,
  setDefaultSettings,
} from '@ragu-components/ord-providers';
import { dataSchema } from '@ragu-components/ord-types';

import { Loading } from 'src/components/loading/Loading';
import { App, Layout } from 'src/views/App';

import type { OrdClientConfig } from '@ragu-components/ord-providers';

const Ingord = (): React.ReactElement => {
  // Set default settings before React-Admin initializes
  setDefaultSettings();

  const [config, setConfig] = useState<OrdClientConfig | undefined>();

  useEffect(() => {
    void fetchClientConfig(CONFIG_PATH)
      .then(setConfig)
      .catch(() => {
        setConfig({});
      });
  }, []);

  const clientConfig = useMemo(() => {
    if (config == null) return null;
    const cfg = createConfig(config, 'ingord');
    setupBaseConfig(cfg);
    return cfg;
  }, [config]);

  if (clientConfig == null) return <Loading />;

  return (
    <DataSchemaContext.Provider value={dataSchema}>
      <ConfigContext.Provider value={clientConfig}>
        <App theme={clientConfig.theme} title={clientConfig.title} layout={Layout} />
      </ConfigContext.Provider>
    </DataSchemaContext.Provider>
  );
};

export default Ingord;
